import type { LeisureSearchRequestBody, LeisureCategory, LeisureCategoryResponse } from '@weberus/shared-types';
import type { QuickFilterWithGlobalFlag } from './search-filter';
import { atom } from 'jotai';
import { isNil, omitBy } from 'lodash-es';
import { globalFilterParamsAtom, searchFilterKeywordAtom, searchTypeAtom, searchFilterSortAtom } from './search-filter';

// 단순 상태를 관리하는 atom - BEGIN
export const pageNameAtom = atom<'KEYWORD' | 'CATEGORY'>('KEYWORD');
export const largeCategoryAtom = atom<number | undefined>(undefined);
export const mediumCategoryAtom = atom<number | undefined>(undefined);

export const leisureCategoryDataAtom = atom<LeisureCategoryResponse | undefined>(undefined);
export const listNameForClientLogAtom = atom((get) => {
  const pageName = get(pageNameAtom);
  return pageName === 'KEYWORD' ? 'search' : 'general';
});

export const leisureListReqBodyAtom = atom<LeisureSearchRequestBody | undefined>(undefined);
// 단순 상태를 관리하는 atom - END

/** [getter] SearchRequestParams 계산된 상태 */
export const leisureHeaderReqBodyAtom = atom((get) => {
  const pageName = get(pageNameAtom);
  const keyword = get(searchFilterKeywordAtom);
  const sort = get(searchFilterSortAtom);
  const filters = get(globalFilterParamsAtom);
  const searchType = get(searchTypeAtom);
  const largeCategory = get(largeCategoryAtom);
  const mediumCategory = get(mediumCategoryAtom);

  return omitBy(
    {
      pageName,
      keyword, // SRP
      sort,
      filters,
      searchType, // 숏컷탭 (구 smallcat)
      largeCategory,
      mediumCategory,
    },
    (value) => isNil(value) || value === '',
  ) as unknown as LeisureSearchRequestBody;
});

// category 상태를 관리 -- BEGIN
export const baseCategoryAtom = atom<{
  mediumCategory: LeisureCategory | undefined;
  smallCategory: LeisureCategory | undefined;
}>({
  mediumCategory: undefined,
  smallCategory: undefined,
});
atom<QuickFilterWithGlobalFlag | undefined>(undefined);
export const categoryAtom = atom(
  (get) => get(baseCategoryAtom),
  (get, set, data: { mediumCatId: number | undefined; searchType: string | undefined }) => {
    const leisureCategory = get(leisureCategoryDataAtom) || [];
    const currentCategory = get(baseCategoryAtom);

    if (!Object.hasOwn(data, 'mediumCatId') && !Object.hasOwn(data, 'searchType')) {
      return;
    }

    const updatedCategory = { ...currentCategory };

    if (Object.hasOwn(data, 'mediumCatId')) {
      updatedCategory.mediumCategory = data.mediumCatId
        ? leisureCategory.find((item) => item.id === data.mediumCatId) || undefined
        : undefined;
    }

    if (Object.hasOwn(data, 'searchType')) {
      updatedCategory.smallCategory = data.searchType
        ? leisureCategory.find((item) => item.id.toString() === data.searchType) || undefined
        : undefined;
    }

    set(baseCategoryAtom, updatedCategory);
  },
);
// category 상태를 관리 -- END
